import React from "react";
import { DropZoneProvider } from "../contexts/drop-zone-context";
import NowReadyConfiguration from "./components/NowReadyConfiguration";

export default ({id, projectId}) => {
    return (
        <DropZoneProvider>
            <NowReadyConfiguration accountId={id} projectId={projectId}/>
        </DropZoneProvider>
    );
};
